import { classNameParser } from "../../../helpers";
import { InputProps } from "../../../types";
import { useSliderRef } from "./helpers";
import "./round-slider.css";
import "./round-slider.js";

import "./style.css";

type ResponsiveSliderProps = InputProps<number, {
  min?: number|string,
  max?: number|string
}>;

export const ResponsiveSlider = (props: ResponsiveSliderProps) => {
  const { slider, loading, add, subtract } = useSliderRef({ ...props });

  return (
    <div className={classNameParser("responsive-slider--slider-container", props.className)}>
      <div className="responsive-slider--slider">
        <div ref={slider} />
        {!loading && slider.current ?
          <>
            <div className="responsive-slider--card left-0">
              <p className="responsive-slider--label">Minimum</p>
              <p className="responsive-slider--amount">{props.min ? "$ " + props.min : "$ 100"}</p>
            </div>
            <div
              className="responsive-slider--button left-0 rounded-br-full"
              onClick={subtract}
            />
            <div
              className="responsive-slider--button right-0 rounded-bl-full"
              onClick={add}
            />
            <div className="responsive-slider--card right-0">
              <p className="responsive-slider--label">Maximum</p>
              <p className="responsive-slider--amount">{props.max ? "$ " + props.max : "$ 1,500"}</p>
            </div>
          </> : null
        }
      </div>
    </div>
  );
};
